export default __webpack_public_path__ + "static/media/Rule13.8c97f961.png";